// src/index.ts
function stripTrailingSlash(value) {
  return value.replace(/\/$/, "");
}
function readEnv(env, key) {
  const value = env[key]?.trim();
  return value || void 0;
}
function isLocalhostUrl(url) {
  return url.includes("localhost") || url.includes("127.0.0.1");
}
function normalizeImobdeskApiBase(raw) {
  let base = stripTrailingSlash(raw);
  if (base.endsWith("/api/v2")) {
    base = base.slice(0, -"/api/v2".length);
  } else if (base.endsWith("/v2")) {
    base = base.slice(0, -"/v2".length);
  }
  return stripTrailingSlash(base);
}
function readImobdeskApiEnvRaw(env) {
  return readEnv(env, "IMOBDESK_API_URL");
}
function resolveImobdeskApiUrl(env, options = {}) {
  const raw = readImobdeskApiEnvRaw(env);
  if (!raw) return options.fallback ?? "";
  const normalized = normalizeImobdeskApiBase(raw);
  const isDev = options.isDev ?? false;
  const useDevProxy = options.useDevProxyForLocalhost ?? true;
  if (isDev && useDevProxy && isLocalhostUrl(normalized)) {
    return "";
  }
  return normalized;
}
function resolveImobdeskApiV2Url(env, options = {}) {
  const raw = readImobdeskApiEnvRaw(env);
  const devProxyPath = options.devProxyPath ?? "/api/v2";
  const fallbackV2 = options.fallbackV2 ?? "https://api.imobdesk.com.br/api/v2";
  if (!raw) return fallbackV2;
  const normalizedBase = normalizeImobdeskApiBase(raw);
  const isDev = options.isDev ?? false;
  const useDevProxy = options.useDevProxyForLocalhost ?? true;
  if (isDev && useDevProxy && isLocalhostUrl(normalizedBase)) {
    return devProxyPath;
  }
  return `${normalizedBase}/api/v2`;
}
function resolveAdmindeskApiBaseConfig(env, meta = {}) {
  const raw = readImobdeskApiEnvRaw(env);
  const isDev = meta.isDev ?? false;
  if (!raw) {
    return {
      baseUrl: "https://api.imobdesk.com.br/api/v2",
      devDirectBaseUrl: ""
    };
  }
  const normalizedBase = normalizeImobdeskApiBase(raw);
  const isLocal = isLocalhostUrl(normalizedBase);
  if (isDev && isLocal) {
    return {
      baseUrl: "/api/v2",
      devDirectBaseUrl: `${normalizedBase}/api/v2`
    };
  }
  const v2 = raw.includes("/api/v2") ? stripTrailingSlash(raw) : `${normalizedBase}/api/v2`;
  return {
    baseUrl: v2,
    devDirectBaseUrl: ""
  };
}
function resolveAppUrl(env, key, fallback) {
  const raw = readEnv(env, key) ?? fallback;
  return stripTrailingSlash(raw);
}
function resolveLoginAppUrl(env, fallback = "") {
  return resolveAppUrl(env, "LOGIN_APP_URL", fallback);
}
function resolveMainAppUrl(env, fallback = "") {
  return resolveAppUrl(env, "MAIN_APP_URL", fallback);
}
function resolveSuporteAppUrl(env, fallback = "") {
  return resolveAppUrl(env, "SUPORTE_APP_URL", fallback);
}
function resolveAdmindeskAppUrl(env, fallback = "") {
  return resolveAppUrl(env, "ADMINDESK_APP_URL", fallback);
}
function resolveMarketingSiteUrl(env, fallback = "") {
  return resolveAppUrl(env, "WWW_URL", fallback);
}
var ADMIN_APP_LABELS = {
  workspace: "Workspace",
  suporte: "Suporte",
  admindesk: "Admin Desk"
};
function parseUrlOrigin(raw) {
  const trimmed = raw.trim();
  if (!trimmed) return void 0;
  const withScheme = /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
  const schemeEnd = withScheme.indexOf("://");
  if (schemeEnd === -1) return void 0;
  const authorityStart = schemeEnd + 3;
  const slashIdx = withScheme.indexOf("/", authorityStart);
  return slashIdx === -1 ? withScheme : withScheme.slice(0, slashIdx);
}
function normalizeShortcutUrl(raw) {
  const trimmed = raw.trim();
  if (!trimmed) return void 0;
  const withScheme = /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
  const withoutQuery = withScheme.split(/[?#]/)[0];
  if (!parseUrlOrigin(withoutQuery)) return void 0;
  const origin = parseUrlOrigin(withoutQuery);
  const path = withoutQuery.slice(origin.length);
  if (!path || path === "/") return stripTrailingSlash(origin);
  return stripTrailingSlash(withoutQuery);
}
function buildAdminAppShortcuts(options) {
  const entries = [
    { id: "workspace", url: options.workspaceUrl },
    { id: "suporte", url: options.suporteUrl },
    { id: "admindesk", url: options.admindeskUrl }
  ];
  return entries.filter((entry) => {
    if (entry.id === options.current) return false;
    const href = entry.url ? normalizeShortcutUrl(entry.url) : void 0;
    if (!href) return false;
    if (options.currentOrigin) {
      const targetOrigin = parseUrlOrigin(href);
      if (targetOrigin && targetOrigin === options.currentOrigin) return false;
    }
    return true;
  }).map((entry) => ({
    id: entry.id,
    label: ADMIN_APP_LABELS[entry.id],
    href: normalizeShortcutUrl(entry.url)
  }));
}

export { buildAdminAppShortcuts, normalizeImobdeskApiBase, readImobdeskApiEnvRaw, resolveAdmindeskApiBaseConfig, resolveAdmindeskAppUrl, resolveImobdeskApiUrl, resolveImobdeskApiV2Url, resolveLoginAppUrl, resolveMainAppUrl, resolveMarketingSiteUrl, resolveSuporteAppUrl };
//# sourceMappingURL=index.mjs.map
//# sourceMappingURL=index.mjs.map